import { Icon } from "@fanduel/og-fe-library";
import { useState, useCallback, startTransition } from "react";
import { TermsT } from "@/types/horseRacing";
import TermListFilters from "./TermListFilters";
import TermResults from "./TermResults";
import styles from "./termList.module.scss";

interface TermsListProps {
  startingTerms: TermsT;
}

interface SearchEvent {
  preventDefault: () => void;
}

const TermList = ({ startingTerms }: TermsListProps) => {
  const [currentTerms, setCurrentTerms] = useState<TermsT>(startingTerms);
  const [selectedFilterIndex, setSelectedFilterIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const search = useCallback(
    (e: SearchEvent) => {
      e.preventDefault();
      startTransition(() => {
        setSelectedFilterIndex(0);
        if (searchTerm.length === 0) {
          setCurrentTerms(startingTerms);
        } else {
          setCurrentTerms(
            startingTerms.filter(
              (term) =>
                term.description
                  .toLocaleUpperCase()
                  .includes(searchTerm.toLocaleUpperCase()) ||
                term.term
                  .toLocaleUpperCase()
                  .includes(searchTerm.toLocaleUpperCase())
            )
          );
        }
      });
    },
    [searchTerm, startingTerms]
  );

  const clearForm = () => {
    setSearchTerm("");
  };

  const filterChangeHandler = (index: number) => {
    setSelectedFilterIndex(index);
    if (index === 0) {
      setCurrentTerms(startingTerms);
    }
    if (index > 0) {
      const filteredList = startingTerms.filter(
        (term) => term.category === index
      );
      setCurrentTerms(filteredList);
    }
  };
  return (
    <div className={styles.container}>
      <form onSubmit={search} className={styles.searchBoxContainer}>
        <div className={styles.searchBox}>
          <Icon
            iconName="icons.search"
            iconSize={17}
            iconColor="colorBaseGreyDarken1"
          />
          <input
            data-testid="searchInput"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            type="text"
            placeholder="What are you looking for?"
          />
          <input
            type="reset"
            value="X"
            alt="Clear the search form"
            onClick={() => {
              clearForm();
              filterChangeHandler(selectedFilterIndex);
            }}
            disabled={searchTerm.length === 0}
          />
          <button
            data-testid="searchButton"
            onClick={search}
            type="button"
            disabled={searchTerm.length === 0}
          >
            Search
          </button>
        </div>
      </form>
      <div className={styles.filtersAndResults}>
        <TermListFilters
          changeHandler={filterChangeHandler}
          selected={selectedFilterIndex}
          setSelected={setSelectedFilterIndex}
        />
        <TermResults currentTerms={currentTerms} />
      </div>
    </div>
  );
};

export default TermList;
